export default __webpack_public_path__ + "static/tablet-8186d7ad4537ac1d007b717af4d41aae.jpg";